import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Slider from 'material-ui/Slider'
import classNames from 'classnames'
import './filter.css'

export class Filter extends Component {

    static propTypes = {
        value: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        min: PropTypes.number,
        max: PropTypes.number,
        step: PropTypes.number,
    }

    render() {
        const { name, label, value, onChange, min = 0, max = 100, step = 1 } = this.props

        return (
            <div className={classNames('settings', `${name}-settings`)}>
                <div className={classNames('label', `${name}-label`)}>
                    {label}
                </div>

                <Slider
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    className={classNames('slider', `${name}-slider`)}
                    sliderStyle={{marginBottom: 0, marginTop:15, width: 200}}
                    onChange={onChange}
                />
            </div>
        )
    }
}
